import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { dlpInsuranceTypes } from "../../Enums/enumValues";
import { Enum } from "../../interfaces/enum";
import { getFullName } from "../../lib/nameUtil";
import { Coverage, DlpState, Premium } from "../../providers/dlpFlow/DlpFlow.interfaces";
import { SummaryTable } from "../summary/SummaryTable";
import { DlpSummaryCoverageData } from "./DlpSummaryCoverageData";

interface Props {
  index: number;
  fields: Record<string, Field<string>>;
  coverage: Partial<Coverage>;
  data: DlpState;
  dictionary: Record<string, string>;
  premiumPerPaymentTerm?: Premium;
}

export const DlpSummaryCoverage = ({ index, coverage, data, fields, premiumPerPaymentTerm, dictionary }: Props) => {
  const hasInsuredPersons = coverage.effectiveInsured?.length !== 0;

  const duration = coverage.duration;
  const amount = coverage.insuredAmount;

  const insuranceTypeValue = (dlpInsuranceTypes() as Enum[]).filter((x) => x.value === coverage.insuranceType);
  const insuranceType = insuranceTypeValue.length ? insuranceTypeValue[0].label : undefined;

  const insuredHeadingId = `DlpSummaryCoverage-insured-heading`;
  const showCoverageData = amount || duration || insuranceType;

  const showSummaryCoverage = hasInsuredPersons && showCoverageData;

  return (
    <>
      {hasInsuredPersons && (
        <>
          <span id={insuredHeadingId} role="heading" aria-level={3} style={{ fontWeight: "bold" }}>
            <Text
              field={coverage.effectiveInsured?.length === 1 ? fields.InsuredPersonTitle : fields.InsuredPersonsTitle}
            />
          </span>
          <SummaryTable aria-labelledby={insuredHeadingId}>
            <tbody>
              {coverage.effectiveInsured?.map((c, i) => {
                const insuredPerson =
                  data.insuredPersons[0].personId === c ? data.insuredPersons[0] : data.insuredPersons[1];

                if (Boolean(insuredPerson.firstName) && Boolean(insuredPerson.dateOfBirth)) {
                  const fullName = getFullName(insuredPerson);
                  const name = fullName === `(${insuredPerson.firstName})` ? insuredPerson.firstName : fullName;
                  return (
                    <tr key={`insured_person_${i}`}>
                      <td>
                        <span>
                          <i className="icon-persoon"></i>
                          {name} - roken: {insuredPerson.isSmoking === "Yes" ? "ja" : "nee"}
                        </span>
                      </td>
                      <td>{insuredPerson.dateOfBirth}</td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </SummaryTable>
        </>
      )}
      {showSummaryCoverage && (
        <DlpSummaryCoverageData {...{ index, coverage, data, fields, premiumPerPaymentTerm, dictionary }} />
      )}
    </>
  );
};
